<template>
	<div class="landing-page contact h-100">
		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>

		<div class="content-container">
			<!-- Hero banner -->
			<div class="hero-banner">
				<div class="container">
					<h1>Contact <template v-if="partnerEnvironment === 'ee'">Likewize</template><template v-else>us</template></h1>
				</div>
			</div>
			<template v-if="!showContactForms">

				<!-- Options -->
				<template v-if="!selectedOption">
					<!-- Categories -->
					<div class="container">
						<h2 class="text-center">What do you need help with?</h2>
						<div class="card-grid grid-col-sm-2 grid-col-md-3">
							<div class="card-link-container" v-for="(option, index) in helpOptions" :key="index">
								<div class="card card-link horizontal" @click="selectOption(option.id)">
									<div class="card-body">
										<component :is="carrierDetails.isInternational ? option.iconInt : option.icon" size="3x"></component>
										<span v-html="option.title"></span>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex mt-5">
							<button class="btn btn-outline-secondary mx-auto" @click="showContactForms = true">I need help with something else</button>
						</div>
					</div>
				</template>

				<!-- Help Page -->
				<contact-repair-cost-guide
					v-if="selectedOption === 'repair-cost'"
					@clearSelection="clearSelectedOption"
					@showContactForms="showContactForms = true"
				></contact-repair-cost-guide>

				<contact-change-date-guide
					v-if="selectedOption === 'change-date'"
					@clearSelection="clearSelectedOption"
					@showContactForms="showContactForms = true"
				></contact-change-date-guide>

				<contact-change-address-guide
					v-if="selectedOption === 'change-address'"
					@clearSelection="clearSelectedOption"
					@showContactForms="showContactForms = true"
				></contact-change-address-guide>

				<contact-track-technician-guide
					v-if="selectedOption === 'track-technician'"
					@clearSelection="clearSelectedOption"
					@showContactForms="showContactForms = true"
				></contact-track-technician-guide>

				<contact-cancel-repair-guide
					v-if="selectedOption === 'cancel-repair'"
					@clearSelection="clearSelectedOption"
					@showContactForms="showContactForms = true"
				></contact-cancel-repair-guide>
			</template>

			<!-- Contact cards -->
			<div class="container" v-if="showContactForms">
				<div class="title">
					<div class="back-btn" @click="showContactForms = false">
						<i class="fa fa-arrow-left"></i>
					</div>
					<h1>How would you like to get in touch?</h1>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="card-grid row" :class="(isOpen && carrierDetails.liveChat) ? 'grid-col-md-3' : 'grid-col-md-2'">
							<div class="card selectable-card no-indicator" v-if="isOpen" v-b-modal.phone-modal>
								<div class="card-body pt-4">
									<icon-call-us size="4x" class="mx-auto mb-3"></icon-call-us>
									<p>Call</p>
								</div>
							</div>
							<div class="card selectable-card no-indicator" v-if="carrierDetails.liveChat && isOpen" @click="openLiveChat()">
								<div class="card-body pt-4">
									<icon-live-chat size="4x" class="mx-auto mb-3"></icon-live-chat>
									<p>Live chat</p>
								</div>
							</div>
							<div class="card selectable-card no-indicator" v-b-modal.message-modal>
								<div class="card-body pt-4">
									<icon-email-us size="4x" class="mx-auto mb-3"></icon-email-us>
									<p>Message</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12 col-lg-10 offset-lg-1 open-times">
						<hr class="bottom-divider" />
						<h3 class="title" v-if="carrierDetails.liveChat">Live chat and phone operation hours</h3>
						<h3 class="title" v-if="!carrierDetails.liveChat">Phone operation hours</h3>
						<h1 class="hours">Monday - Friday, 09:00 - 17:00</h1>
						<h4 class="bank-holidays">(Excluding bank holidays)</h4>
						<p>Alternatively, the <a href="/faqs">help centre</a> could well provide the answer you're looking for.</p>
					</div>
				</div>
			</div>

		</div>

		<!-- Footer -->
		<page-footer></page-footer>

		<!-- Message modal -->
		<message-modal :carrierDetails="carrierDetails"></message-modal>

		<!-- Phone number modal -->
		<phone-modal :carrierDetails="carrierDetails"></phone-modal>

	</div>
</template>

<script>

if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapActions, mapGetters} from "vuex";
import moment from 'moment'

export default {
	name: "ContactIndex",

	data () {
		return {
			helpOptions: [
				{
					title: "How much will my repair cost?",
					icon: "icon-quote",
					iconInt: "icon-quote-dollar",
					id: "repair-cost"
				},
				{
					title: "I need to change my repair date",
					icon: "icon-calendar",
					iconInt: "icon-calendar",
					id: "change-date"
				},
				{
					title: "I need to change my repair address",
					icon: "icon-home",
					iconInt: "icon-home",
					id: "change-address"
				},
				{
					title: "Where is my technician?",
					icon: "icon-van",
					iconInt: "icon-van",
					id: "track-technician"
				},
				{
					title: "I want to cancel my appointment",
					icon: "icon-calendar-cross",
					iconInt: "icon-calendar-cross",
					id: "cancel-repair"
				},
			],
			isOpen: true,
			selectedOption: null,
			showContactForms: false
		}
	},

    beforeMount() {
        this.isOfficeOpen();
    },

	mounted() {
		this.checkBooking().then(() => {
			this.checkBookingIsComplete();
		});
	},

	computed: {
		...mapGetters([
			'carrierDetails',
			'partnerEnvironment'
		])
	},

	methods: {
		...mapActions([
			'checkBooking',
			'checkBookingIsComplete'
		]),

		clearSelectedOption() {
			this.selectedOption = null;
		},

		isOfficeOpen() {
			let openDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
			let openTime = '07:00';
			let closeTime = '17:00';
			let currentDay = moment().format('ddd');
			let currentTime = moment().format('HH:mm');

			if (openDays.includes(currentDay) && currentTime > openTime && currentTime < closeTime) {
				return this.isOpen = true;
			}

			return this.isOpen = false;
		},
		openLiveChat() {
			window.LiveChatWidget.call('maximize')
		},

		selectOption(option) {
			this.selectedOption = option;
		}
	}
}
</script>